import { ADICIONAR_FILTRO_ROTA, LIMPAR_FILTRO_ROTA, LISTAR_FILTROS_ROTA, REMOVER_FILTRO_ROTA } from '../../actions/types'
import { filtroExiste } from '../../util/filtros'

const initialState = undefined

const initial = {}

export const filtrosAdicionadosRota = (state = [], action = initialState) => {
  switch (action.type) {
    case ADICIONAR_FILTRO_ROTA: {
      if (!filtroExiste(state, action.payload)) {
        return state.concat(action.payload)
      }
      return state
    }

    case REMOVER_FILTRO_ROTA: {
      const copia = [...state]
      return copia.filter(filtro => filtro.chave !== action.payload.chave || filtro.valor !== action.payload.valor)
    }

    case LIMPAR_FILTRO_ROTA: {
      return []
    }

    default:
      return state
  }
}

export const filtrosRotas = (state = initial, action) => {
  switch (action.type) {
    case LISTAR_FILTROS_ROTA: {
      return action.payload.data
    }
    default:
      return state
  }
}
